'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import '../../mixins/media.js';
import '../../mixins/keyboardFocus.js';
import '../../mixins/markStyle.js';
import '../../mixins/scrollbarStyle.js';
import '../../mixins/textStyle.js';
import { Flex } from '../Flex/Flex.js';
import { Link } from '../Link/Link.js';
import { Text } from '../Text/Text.js';

const StyledTitle = styled(Text).withConfig({
  componentId: "sc-1j5o7rt-0"
})(["color:", ";", ";"], ({
  theme
}) => theme.components.tile.labelColor, ({
  isDisabled,
  theme
}) => isDisabled && css(["color:", ";"], theme.components.tile.disabledColor));
const StyledLabel = styled.label.withConfig({
  componentId: "sc-1j5o7rt-1"
})(["", ";", ";display:inline-flex;vertical-align:bottom;position:relative;width:100%;"], defaultStyles.boxSizing, defaultStyles.fontSmoothing);
const StyledDescription = styled(Text).withConfig({
  componentId: "sc-1j5o7rt-2"
})(["color:", ";margin-top:", ";", ";"], ({
  theme
}) => theme.components.tile.descriptionColor, ({
  theme
}) => theme.components.tile.labelMarginBottom, ({
  isDisabled,
  theme
}) => isDisabled && css(["color:", ";"], theme.components.tile.disabledColor));
const StyledTileButton = styled.div.withConfig({
  componentId: "sc-1j5o7rt-3"
})(["", ";min-height:", ";position:relative;display:flex;justify-content:center;flex-direction:column;width:100%;align-items:", ";padding:", ";border:1px solid ", ";background-color:", ";border-radius:", ";transition:border-color 200ms ease-in-out,background-color 200ms ease-in-out;cursor:pointer;", ";.is-focussed &&,label:hover &&{text-decoration:none;border-color:", ";background-color:", ";}", ";", ";"], defaultStyles.boxSizing, ({
  theme
}) => theme.components.input.size.m.height, ({
  isCentered
}) => isCentered ? 'center' : 'flex-start', ({
  theme
}) => theme.components.tile.padding, ({
  theme
}) => theme.components.tile.borderColor, ({
  theme
}) => theme.components.tile.backgroundColor, ({
  theme
}) => theme.components.tile.borderRadius, ({
  isFocused,
  theme
}) => isFocused && css(["border-color:", ";background-color:", ";"], theme.components.tile.focussedBorderColor, theme.components.tile.focussedBackgroundColor), ({
  theme,
  isDisabled
}) => isDisabled ? theme.components.tile.disabledBorderColor : theme.components.tile.focussedBorderColor, ({
  theme,
  isDisabled
}) => isDisabled ? theme.components.tile.disabledBackgroundColor : theme.components.tile.focussedBackgroundColor, ({
  isChecked,
  isFocused,
  theme
}) => isChecked && css(["border-color:", ";background-color:", ";", ""], theme.components.tile.checkedBorderColor, theme.components.tile.checkedBackgroundColor, isFocused && css(["border-color:", ";background-color:", ";"], theme.components.tile.focussedBorderColor, theme.components.tile.focussedBackgroundColor)), ({
  isDisabled,
  theme
}) => isDisabled && css(["color:", ";border-color:", ";background-color:", ";cursor:default;"], theme.components.tile.disabledColor, theme.components.tile.disabledBorderColor, theme.components.tile.disabledBackgroundColor));
const StyledIconWrapper = styled(Flex).withConfig({
  componentId: "sc-1j5o7rt-4"
})(["margin-bottom:", ";color:", ";", ";"], ({
  theme
}) => theme.components.tile.iconMarginBottom, ({
  theme
}) => theme.components.tile.iconColor, ({
  isDisabled,
  theme
}) => isDisabled && css(["color:", ";"], theme.components.tile.disabledColor));
const TileButton = /*#__PURE__*/withTitan(_a => {
  var {
      icon,
      label,
      labelHtmlFor,
      labelAria,
      description,
      isDisabled,
      testId = 'tileButton'
    } = _a,
    rest = __rest(_a, ["icon", "label", "labelHtmlFor", "labelAria", "description", "isDisabled", "testId"]);
  return jsx(StyledLabel, {
    "data-test-id": testId,
    htmlFor: labelHtmlFor,
    children: jsxs(StyledTileButton, Object.assign({
      as: rest.to || rest.onClick ? Link : 'div',
      isDisabled: isDisabled
    }, rest, {
      children: [icon && jsx(StyledIconWrapper, {
        "aria-hidden": "true",
        "data-test-id": `${testId}Icon`,
        isDisabled: isDisabled,
        children: icon
      }), jsx(StyledTitle, {
        "aria-label": labelAria,
        "data-test-id": `${testId}Label`,
        isDisabled: isDisabled,
        type: "label",
        children: label
      }), description && jsx(StyledDescription, {
        "data-test-id": `${testId}Description`,
        isDisabled: isDisabled,
        type: "labelSmall",
        children: description
      })]
    }))
  });
}, {
  name: 'TileButton'
});

export { TileButton };
//# sourceMappingURL=TileButton.js.map
